export default __webpack_public_path__ + "static/Face-institute-logo-99789763b9ce87e55e67c48dd4285deb.png";